var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("navigateable-tab", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var tabId = ref.tabId
          return [_c("question-tab", { attrs: { tabId: tabId } })]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }